export enum VAT_STATUS {
  TTC = 'TTC',
  HT = 'HT',
}
